module.exports = __webpack_public_path__ + "img/user-4.54abfbe7.png";